(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'd2v-core-js'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'd2v-core-js'.");
    }
    root['d2v-core-js'] = factory(typeof this['d2v-core-js'] === 'undefined' ? {} : this['d2v-core-js'], kotlin);
  }
}(this, function (_, Kotlin) {
  'use strict';
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var until = Kotlin.kotlin.ranges.until_dqglrj$;
  var get_lastIndex = Kotlin.kotlin.collections.get_lastIndex_55thoc$;
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var numberToDouble = Kotlin.numberToDouble;
  var lazy = Kotlin.kotlin.lazy_klfg04$;
  var numberToInt = Kotlin.numberToInt;
  var IntRange = Kotlin.kotlin.ranges.IntRange;
  var math = Kotlin.kotlin.math;
  var Math_0 = Math;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  var collectionSizeOrDefault = Kotlin.kotlin.collections.collectionSizeOrDefault_ba2ldo$;
  var Point$Companion_instance = null;
  function cssclass() {
    return new CssClassDelegate();
  }
  function CssClassDelegate() {
  }
  CssClassDelegate.prototype.getValue_n5byny$ = function (from, property) {
    return new CssClass(property.callableName);
  };
  CssClassDelegate.$metadata$ = {kind: Kind_CLASS, simpleName: 'CssClassDelegate', interfaces: []};
  function CssClass(name) {
    this.name = name;
  }
  CssClass.$metadata$ = {kind: Kind_CLASS, simpleName: 'CssClass', interfaces: []};
  CssClass.prototype.component1 = function () {
    return this.name;
  };
  CssClass.prototype.copy_61zpoe$ = function (name) {
    return new CssClass(name === void 0 ? this.name : name);
  };
  CssClass.prototype.toString = function () {
    return 'CssClass(name=' + Kotlin.toString(this.name) + ')';
  };
  CssClass.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.name) | 0;
    return result;
  };
  CssClass.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && Kotlin.equals(this.name, other.name))));
  };
  var namespace$Companion_instance = null;
  var e10;
  var e5;
  var e2;
  function ln10$lambda() {
    return Math_0.log(10.0);
  }
  var ln10;
  var EPSILON;
  var EPSILON2;
  var PI;
  var HALFPI;
  var THIRDPI;
  var QUARTERPI;
  var TAU;
  var TAU_EPSILON;
  var PI_ANGLE;
  var HALFPI_ANGLE;
  var TAU_ANGLE;
  var DEG_TO_RAD;
  var RAD_TO_DEG;
  function toRadians($receiver) {
    return $receiver * DEG_TO_RAD;
  }
  function get_deg($receiver) {
    return new Angle(numberToDouble($receiver) * DEG_TO_RAD);
  }
  function Angle(rad) {
    this.rad = rad;
  }
  Object.defineProperty(Angle.prototype, 'cos', {get: function () {
    var x = this.rad;
    return Math_0.cos(x);
  }});
  Object.defineProperty(Angle.prototype, 'sin', {get: function () {
    var x = this.rad;
    return Math_0.sin(x);
  }});
  Object.defineProperty(Angle.prototype, 'tan', {get: function () {
    var x = this.rad;
    return Math_0.tan(x);
  }});
  Object.defineProperty(Angle.prototype, 'deg', {get: function () {
    return this.rad * RAD_TO_DEG;
  }});
  Angle.prototype.normalize = function () {
    return this.rad >= 0 ? new Angle(this.rad % TAU_ANGLE.rad) : new Angle(this.rad % TAU_ANGLE.rad + TAU_ANGLE.rad);
  };
  Angle.prototype.plus_5t6zck$ = function (angle) {
    return new Angle(this.rad + angle.rad);
  };
  Angle.prototype.minus_5t6zck$ = function (angle) {
    return new Angle(this.rad - angle.rad);
  };
  Angle.prototype.times_3p81yu$ = function (d) {
    return new Angle(this.rad * numberToDouble(d));
  };
  Angle.prototype.div_3p81yu$ = function (d) {
    return new Angle(this.rad / numberToDouble(d));
  };
  Angle.prototype.div_5t6zck$ = function (other) {
    return this.rad / other.rad;
  };
  Angle.$metadata$ = {kind: Kind_CLASS, simpleName: 'Angle', interfaces: []};
  Angle.prototype.component1 = function () {
    return this.rad;
  };
  Angle.prototype.copy_14dthe$ = function (rad) {
    return new Angle(rad === void 0 ? this.rad : rad);
  };
  Angle.prototype.toString = function () {
    return 'Angle(rad=' + Kotlin.toString(this.rad) + ')';
  };
  Angle.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.rad) | 0;
    return result;
  };
  Angle.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && Kotlin.equals(this.rad, other.rad))));
  };
  var package$io = _.io || (_.io = {});
  var package$data2viz = package$io.data2viz || (package$io.data2viz = {});
  var package$core = package$data2viz.core || (package$data2viz.core = {});
  package$core.cssclass = cssclass;
  package$core.CssClassDelegate = CssClassDelegate;
  package$core.CssClass = CssClass;
  var package$math = package$data2viz.math || (package$data2viz.math = {});
  Object.defineProperty(package$math, 'PI', {get: function () {
    return PI;
  }});
  Object.defineProperty(package$math, 'THIRDPI', {get: function () {
    return THIRDPI;
  }});
  package$math.toRadians_yrwdxr$ = toRadians;
  package$math.get_deg_rcaex3$ = get_deg;
  package$math.Angle = Angle;
  e10 = Math_0.sqrt(50.0);
  e5 = Math_0.sqrt(10.0);
  e2 = Math_0.sqrt(2.0);
  ln10 = lazy(ln10$lambda);
  EPSILON = 1.0E-6;
  EPSILON2 = EPSILON * EPSILON;
  PI = math.PI;
  HALFPI = PI / 2.0;
  THIRDPI = PI / 3.0;
  QUARTERPI = PI / 4.0;
  TAU = PI * 2.0;
  TAU_EPSILON = TAU - EPSILON;
  PI_ANGLE = new Angle(math.PI);
  HALFPI_ANGLE = PI_ANGLE.div_3p81yu$(2);
  TAU_ANGLE = PI_ANGLE.times_3p81yu$(2);
  DEG_TO_RAD = math.PI / 180;
  RAD_TO_DEG = 180 / math.PI;
  return _;
}));

//# sourceMappingURL=d2v-core-js.js.map



//////////////////
// WEBPACK FOOTER
// ./build/kotlin-js-min/main/d2v-core-js.js
// module id = 2
// module chunks = 0